<template>
    <div class="py-1" style="width: 100%">
        <TextArea v-model="text" 
                @update:model-value="updateSpecManager"/>
    </div>
</template>

<script lang="ts">
import TextArea from "@/components/editorMenu/Editor.vue";
import { Component, Vue, toNative, Watch, Model, Emit } from "vue-facing-decorator";

@Component({
    components: {
        TextArea,
    },
})
export class TaxFormFormattedText extends Vue {
    @Model({ default: "" }) text: string;

    @Watch("text")
    @Emit("updateSpecManager")
    updateSpecManager() {
        return this.text;
    }
}

export default toNative(TaxFormFormattedText);
</script>
